import style from './style.module.less';
import logo from '../../img/svg/pohColor.svg';

const Logo = () => (
  <span className={style.logo}>
    <img src={logo} alt="Пох" />
    <h3 className={style.caption}>
      Походники
      <br />
      Пензы
    </h3>
  </span>
);

export default Logo;
